import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const p = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "m14.2129 10.0386-1.1706 1.1706-4.66044 4.6604L7.2002 14.699l4.6604-4.6604-4.6604-4.66042L8.38186 4.1965l4.66044 4.67146 1.1706 1.17064Z" }) });
export {
  p as MoreThan
};
//# sourceMappingURL=MoreThan.js.map
